/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FarmacoDto } from '../../models/farmaco-dto';

export interface FarmacosControllerGetFarmacosPaciente$Params {
  programaUuid: string;
}

export function farmacosControllerGetFarmacosPaciente(http: HttpClient, rootUrl: string, params: FarmacosControllerGetFarmacosPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FarmacoDto>>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerGetFarmacosPaciente.PATH, 'get');
  if (params) {
    rb.path('programaUuid', params.programaUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FarmacoDto>>;
    })
  );
}

farmacosControllerGetFarmacosPaciente.PATH = '/api/farmacos/farmacos-paciente/{programaUuid}';
